import styled from 'styled-components'

import { HintContainer as DefaultHintContainer } from '../Shared'

export const HintContainer = styled(DefaultHintContainer)`
	margin-top: 0;
`
